import { Button } from '@zorro/design-system/v2/Button';
import { Card } from '@zorro/design-system/v2/Card';
import { Group } from '@zorro/web/design-system';

type Props = {
  onClick: () => void;
  label: string;
  isDisabled: boolean;
};

export const EmployeePagePlansEmptyBenefitCard = ({
  isDisabled,
  onClick,
  label,
}: Props) => {
  return (
    <Card variant="white-shadow" p="xl">
      <Group justify="space-between">
        No selected plans
        <Button
          disabled={isDisabled}
          variant="secondary"
          onClick={onClick}
          size="lg"
        >
          {label}
        </Button>
      </Group>
    </Card>
  );
};
